import { createSelector } from 'reselect';
import { get } from 'lodash/fp';
import { getStringProp } from '@mews/fp';
import { getOrEmptyArray } from '@mews-commander/utils';
import { moduleSelector } from '../module';

export const messagesSelector = createSelector(moduleSelector, get('messages'));
export const draftsSelector = createSelector(moduleSelector, get('drafts'));
export const loadingMessagesSelector = createSelector(moduleSelector, get('loadingMessages'));

export const getMessages = createSelector(getStringProp('threadId'), messagesSelector, getOrEmptyArray);
